// Copyright (c) Bentley Systems
import { Textarea } from "@itwin/itwinui-react";
import { TextareaHTMLAttributes, useEffect, useState } from "react";
import {
  sanitizeInputCurrentValue,
  skipsSanitization,
} from "./text-input-components-helper";
import { EfFieldValidationTypeEnum } from "../../Helpers/enumerators";
import { validateField } from "../../Helpers/helper-functions";

export type BecsTextAreaProps = {
  validationType: EfFieldValidationTypeEnum;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextAreaComponent = ({
  onStatusChange,
  ...props
}: BecsTextAreaProps & {
  onStatusChange?: (status: "positive" | "warning" | undefined) => void;
}) => {
  const [status, setStatus] = useState<"positive" | "warning" | undefined>(
    undefined,
  ); // Initialize with null for no status

  useEffect(() => {
    if (onStatusChange) {
      onStatusChange(status);
    }
  }, [status, onStatusChange]);

  function validateIntInput(event: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (
      !/[0-9]/.test(event.key) &&
      event.key !== "Delete" &&
      event.key !== "Backspace"
    ) {
      event.preventDefault();
    }
  }

  function onKeyDown(event: React.KeyboardEvent<HTMLTextAreaElement>): void {
    if (props.validationType === EfFieldValidationTypeEnum.IntType) {
      validateIntInput(event);
    }
    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
  }
  return (
    <Textarea
      required={props.required}
      status={status}
      placeholder="Enter text here..."
      style={props.style}
      disabled={props.disabled}
      maxLength={props.maxLength}
      defaultValue={props.defaultValue}
      onChange={(currentValue) => {
        if (!skipsSanitization(props.validationType)) {
          const sanitizedValue = sanitizeInputCurrentValue(
            currentValue.target.value,
          );
          currentValue.target.value = sanitizedValue;
        }

        let isFieldValid = false;
        // Check if field is required and empty
        if (props.required !== true && currentValue.target.value === "") {
          isFieldValid = true;
        }
        // Validate input and update status directly
        else {
          isFieldValid = validateField(
            currentValue.target.value,
            props.validationType,
          );
        }

        setStatus(isFieldValid ? "positive" : "warning"); // Set status directly
        if (props.onChange) {
          props.onChange(currentValue);
        }
      }}
      onBlur={props.onBlur}
      onKeyDown={onKeyDown}
    />
  );
};

export default TextAreaComponent;
